import React, { useEffect, useState } from 'react';

import { PhoneDetails } from './PhoneCta';

// TODO: Come up with a way to detect AU

const ACCESS_KEY = process.env.GATSBY_IP_STACK_ACCESS_KEY;

type Props = {
  /** The location target of the page. Passed down from the page template via Section component  */
  location: string;
};

/** A component to control the logic of displaying a phone number call to action */
const PhoneCtaContainer = ({ location }: Props): JSX.Element => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    // Replace 'check' with an Australian IP address to test if it picks up the AU country code.
    fetch(`https://api.ipstack.com/check?access_key=${ACCESS_KEY}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  const countryCode = items.country_code;

  // Show US Number as the default if 'countryCode' isnt available
  if (error) {
    return <PhoneDetails phoneNumber="+1 512 846-3011" />;
  }
  // Check for NZ or AU as countryCode then display the corresponding phone number
  if (countryCode === 'NZ') {
    return <PhoneDetails phoneNumber="+64 9 886 3309" />;
  }
  if (countryCode === 'AU') {
    return <PhoneDetails phoneNumber="02 5104 6116" />;
  }
  // If it shows any other than NZ or AU show the US number
  return <PhoneDetails phoneNumber="+1 512 846-3011" />;
};

export default PhoneCtaContainer;
